import { render, staticRenderFns } from "./EntityCounterItem.vue?vue&type=template&id=6062a110&"
import script from "./EntityCounterItem.vue?vue&type=script&lang=ts&"
export * from "./EntityCounterItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports